/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Change_Type_ModifiedInputs */



/**
* | output |
* | --- |
* | "modified" |
*
* @param {Compare_Event_Groups_Csv_Change_Type_ModifiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_change_type_modified = /** @type {((inputs?: Compare_Event_Groups_Csv_Change_Type_ModifiedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Change_Type_ModifiedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("modifié")
	if (locale === "de") return /** @type {LocalizedString} */ ("modifiziert")
	if (locale === "it") return /** @type {LocalizedString} */ ("modificato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("модифицированный")
	if (locale === "es") return /** @type {LocalizedString} */ ("modificado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("修改的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("変更された")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संशोधित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("modificado")
	return /** @type {LocalizedString} */ ("modified")
});